import { ApiResponse } from '@nohara-dxdev/oidc-core';
import { QueryConfig } from '@nohara-dxdev/react-core';
import { useScopeIds } from '@nohara-dxdev/react-oidc';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { BuildingStructure } from '@/types/api';

export const getBuildings = async (
  orgId: string,
  projectId: string,
): Promise<BuildingStructure[]> => {
  const { data } = await api.get<any, ApiResponse<BuildingStructure[]>>(
    `/orgs/${orgId}/projects/${projectId}/buildings`,
  );
  return data;
};

export const getBuildingsQueryKey = (orgId?: string, projectId?: string) => {
  return ['org', orgId, 'project', projectId, 'buildings'];
};

export const getBuildingsQueryOptions = (orgId?: string, projectId?: string) => {
  return queryOptions({
    queryKey: getBuildingsQueryKey(orgId, projectId),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => getBuildings(orgId!, projectId!),
    enabled: !!orgId && !!projectId,
  });
};

interface UseBuildingsOptions {
  queryConfig?: QueryConfig<typeof getBuildingsQueryOptions>;
}

export const useBuildings = ({ queryConfig }: UseBuildingsOptions = {}) => {
  const { orgId, projectId } = useScopeIds();
  return useQuery({
    ...getBuildingsQueryOptions(orgId, projectId),
    ...queryConfig,
  });
};
